/**
 * Fire-hydrant map marker icon.
 *
 * The Material Design Icons "fire-hydrant" glyph, always red — the same symbol
 * (and color) the LadderApp field app draws for hydrant markers
 * (react-native-vector-icons MaterialCommunityIcons `fire-hydrant`, red) — so
 * the station board and the mobile app show an identical hydrant.
 *
 * One source of truth so the Mapbox and Google renderers draw identical markers
 * — Mapbox renders the raw SVG string inline, Google Maps consumes the data-URI
 * form as a Marker icon.
 *
 * A thin dark outline keeps the glyph legible on any map background. The source
 * viewBox is square (24x24), so the width and height are kept equal to avoid
 * distorting the artwork; a bottom-center anchor lands the hydrant's base on the
 * {lat,lng} coordinate.
 */

// Material Design Icons — "fire-hydrant" (24x24 viewBox).
// https://pictogrammers.com/library/mdi/icon/fire-hydrant/
const MDI_FIRE_HYDRANT_PATH =
  "M5 15V14H4V12H5V11H7V15H5M19 12V11H17V15H19V14H20V12H19M18 6H15.86C15.5 4.6 14.4 "
  + "3.5 13 3.14V2H11V3.14C9.6 3.5 8.5 4.6 8.14 6H6V8H18V6M18 22H6C6 20.9 6.9 20 8 20V9H16V20C17.11 "
  + "20 18 20.9 18 22M10 13C10 14.11 10.9 15 12 15S14 14.11 14 13 13.11 11 12 11 10 11.9 10 13Z";

const VIEW = 24;

export const HYDRANT_ICON_W = 28;
export const HYDRANT_ICON_H = 28;
// Hydrants are always red, matching the LadderApp field app.
export const HYDRANT_ICON_COLOR = "red";

/** Raw <svg> string for the red hydrant marker. */
export function hydrantIconSvg({ width = HYDRANT_ICON_W, height = HYDRANT_ICON_H } = {}) {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${VIEW} ${VIEW}" width="${width}" height="${height}">`
    + `<path d="${MDI_FIRE_HYDRANT_PATH}" fill="${HYDRANT_ICON_COLOR}" stroke="#1c1c1c" stroke-width="0.75" stroke-linejoin="round" paint-order="stroke"/>`
    + `</svg>`;
}

/** data:image/svg+xml URI form (for Google Maps Marker `icon.url` or <img src>). */
export function hydrantIconDataUri(opts) {
  return `data:image/svg+xml,${encodeURIComponent(hydrantIconSvg(opts))}`;
}
